import { __module as t } from "./ghl-ui.es1709.js";
import { i as x } from "./ghl-ui.es1541.js";
import { t as _ } from "./ghl-ui.es1631.js";
import { s as v } from "./ghl-ui.es1710.js";
import { s as E } from "./ghl-ui.es1711.js";
import { r as g } from "./ghl-ui.es1637.js";
(function(f, r) {
  var e = x.default;
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = p;
  var i = e(_), u = e(v), s = e(E), d = e(g), m = 6048e5;
  function p(n, a) {
    (0, d.default)(1, arguments);
    var o = (0, i.default)(n), l = (0, u.default)(o, a).getTime() - (0, s.default)(o, a).getTime();
    return Math.round(l / m) + 1;
  }
  f.exports = r.default;
})(t, t.exports);
var O = t.exports;
export {
  O as g
};
